import { HIDDEN_BORDER, PROXIMA_NOVA, TRANSPARENT } from '../theme/settings';

export const overrides = {
    MuiListItem: {
        root: {
            '&.MuiListItem-root.NeptuneDropdown-placeholder': {
                background: TRANSPARENT
            }
        }
    },
    MuiButton: {
        root: {
            fontFamily: PROXIMA_NOVA,
            borderRadius: '5px',
            fontSize: '16px',
            padding: '0 16px',
            fontWeight: 400,
            textTransform: 'none',
            lineHeight: 2.2,
            '& .NeptuneButton-loader': {
                marginRight: 10
            }
        },

        contained: {
            boxShadow: 'none',

            '&:hover, &:focus, &:active': {
                boxShadow: 'none'
            }
        },

        containedPrimary: {
            backgroundColor: '#aaa',
            color: '#000',

            '&:hover, &:focus, &:active': {
                backgroundColor: '#bbb'
            },

            '&:disabled': {
                border: `0.5px solid ${TRANSPARENT}`
            }
        },

        containedSecondary: {
            backgroundColor: '#ccc',
            color: '#000',

            '&:hover, &:focus, &:active': {
                backgroundColor: '#ddd'
            }
        },

        textPrimary: {
            '&:hover, &:focus, &:active': {
                backgroundColor: TRANSPARENT
            }
        },

        outlined: {
            padding: '0 15px',
            lineHeight: 2.1
        },

        outlinedPrimary: {
            border: HIDDEN_BORDER,
            color: '#000',

            '&:hover, &:focus, &:active': {
                border: HIDDEN_BORDER,
                backgroundColor: TRANSPARENT
            }
        },

        outlinedSecondary: {
            border: HIDDEN_BORDER,
            background: TRANSPARENT,
            color: '#000',

            '&:hover, &:focus, &:active': {
                border: HIDDEN_BORDER,
                backgroundColor: TRANSPARENT
            }
        },

        outlinedSizeLarge: {
            boxSizing: 'border-box',
            fontSize: '21px',
            padding: '0 21px',
            lineHeight: 2.465
        }
    }
};

export const props = {
    MuiButton: {
        size: 'medium',
        variant: 'contained',
        disableElevation: true,
        disableTouchRipple: true,
        disableRipple: true
    }
};
